import { axiosPatient } from "./generic/AxiosInterceptor/AxiosInterceptor"

export const getEpisodes = () => {
  return axiosPatient({
    url: "/patient/episodes",
    method: "get",
  }).then((resp) => resp.data)
}

export const getEpisode = (episodeId: string) => {
  return axiosPatient({
    url: "/patient/episode",
    method: "get",
    params: {
      episodeId,
    },
  }).then((resp) => resp.data)
}
